import { MediaType } from '../MediaType';
// eslint-disable-next-line no-restricted-imports
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

/**
 * This mutation is only used for removing unlicensed permissions.
 * Refer to other GraphQL queries if updating other space properties or permissions.
 */
export const experimentalRemoveUnlicensedPermission: ExperimentalMutations['experimentalRemoveUnlicensedPermission'] =
	async (_, { permissionId, spaceKey }, { network: { cfetch } }) => {
		const response = await cfetch(`/wiki/rest/api/space/${spaceKey}/permission/${permissionId}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		});
		return {
			success: response.status === 204,
		};
	};
